import { render, staticRenderFns } from "./DuplicateDialog.vue?vue&type=template&id=20232312&"
import script from "./DuplicateDialog.vue?vue&type=script&lang=js&"
export * from "./DuplicateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20232312')) {
      api.createRecord('20232312', component.options)
    } else {
      api.reload('20232312', component.options)
    }
    module.hot.accept("./DuplicateDialog.vue?vue&type=template&id=20232312&", function () {
      api.rerender('20232312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Common/Modals/DuplicateDialog.vue"
export default component.exports